import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import userReducer from './reducers/user.reducer';
import messagesReducer from './reducers/messages.reducer';
import { encryptedStorage } from '../utils/persistEncryption';

const persistConfig = {
  key: 'root',
  storage: encryptedStorage, // AES-GCM encrypted, session key in sessionStorage
  whitelist: ['user'], // Only persist user state (messages are in-memory only)
};

const rootReducer = combineReducers({
  user: userReducer,
  messages: messagesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;